export default __webpack_public_path__ + "images/Reach-Bo-high-relief-tympanum.webp";